/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useCallback, useEffect, useState } from 'react';
import parse from 'html-react-parser';
import { Plus, Remove } from 'sushiweb/Icons';
import './GuidelineNode.scss';
import {
  helpNodeCloseEvent,
  helpNodeOpenEvent,
  helpNodeShownEvent,
  helpNonPrimaryNodeShownEvent,
} from '../../analytics/events';
import { MetricsForJumboEvent } from '../../analytics/constants';

const GuidelineNode = ({
  orderId,
  node,
  setCurrentNodeParentId,
  callBack,
  isDefaultOpen,
}) => {
  const [content, setContent] = useState(null);
  const [viewAll, setViewAll] = useState(false);

  useEffect(() => {
    setCurrentNodeParentId(node?.parent_id);
  }, [callBack, node]);

  useEffect(() => {
    const cont = parseHtmlWithLineBreaks(node?.content);
    setContent(cont);
    if (isDefaultOpen) {
      setViewAll(true);
      helpNodeShownEvent({
        feature_meta: {
          node_id: node?.id,
          is_default_open: true,
        },
        [MetricsForJumboEvent.order_id]: orderId,
      });
    } else {
      helpNonPrimaryNodeShownEvent({
        [MetricsForJumboEvent.order_id]: orderId,
        [MetricsForJumboEvent.feature_meta]: {
          node_id: node?.id,
          is_default_open: false,
        },
      });
    }
  }, [node, isDefaultOpen]);

  const parseHtmlWithLineBreaks = useCallback(
    (Html) => {
      const htmlWithLineBreaks = Html.replace(/\n/g, '</br>');
      return htmlWithLineBreaks;
    },
    [node],
  );

  const handleView = useCallback(() => {
    setViewAll((prevState) => {
      if (prevState)
        helpNodeCloseEvent({
          [MetricsForJumboEvent.order_id]: orderId,
          [MetricsForJumboEvent.feature_meta]: {
            node_id: node?.id,
          },
        });
      else
        helpNodeOpenEvent({
          [MetricsForJumboEvent.order_id]: orderId,
          [MetricsForJumboEvent.feature_meta]: {
            node_id: node?.id,
            is_default_open: false,
          },
        });
      return !prevState;
    });
  }, [setViewAll]);

  return (
    <div
      className={`tw-bg-base-white  tw-rounded-xl tw-py-4 tw-px-5 tw-cursor-auto tw-w-full tw-flex tw-justify-between `}
    >
      <div id={`guideline_node_${node?.id}`} className='guidelineCss tw-w-full'>
        {viewAll ? (
          content && (
            <div className='tw-flex-col tw-w-full '>
              <div
                className='tw-text-green-700 tw-text-300 tw-font-medium tw-flex tw-w-full tw-justify-between tw-cursor-pointer tw-mb-6'
                onClick={handleView}
              >
                <span className='tw-text-200  tw-font-semibold'>
                  {node?.title}
                </span>
                <Remove size={15} color={'#318616'} />
              </div>
              {parse(content)}
            </div>
          )
        ) : (
          <div
            className=' tw-flex tw-w-full tw-justify-between  tw-cursor-pointer'
            onClick={handleView}
          >
            <span className='tw-text-200 tw-font-medium'>{node?.title}</span>{' '}
            <Plus size={15} color={'#318616'} />
          </div>
        )}
      </div>
    </div>
  );
};

export default GuidelineNode;
